'use client'
import { tw } from 'utils/classnames'
import { useUserQuery } from 'auth/hooks'
import type { Clubhouse } from 'codegen/types'
import dynamic from 'next/dynamic'

import { MembersBox } from './members-box'
import { AssetsBox } from './assets-box'
import { ProjectsBox } from './projects-box'
import { BirthdayBox } from './birthday-box'
const DynamicSearchProvider = dynamic(
  () => import('../search/provider').then(m => m.SearchPageProvider),
  {
    ssr: false,
  },
)

export function DetailsBox({ slug, clubhouse }: { slug: string; clubhouse?: Clubhouse | null }) {
  const { data: isCFUser } = useUserQuery(undefined, {
    select: data => data.me?.user?.email?.endsWith('@creativefabrica.com'),
  })

  return (
    <DynamicSearchProvider>
      <div
        className={tw(
          'relative flex w-full flex-col gap-2 md:grid md:gap-6',
          isCFUser ? 'lg:grid-cols-4' : 'lg:grid-cols-3',
        )}
      >
        <MembersBox slug={slug} initialTotalMember={clubhouse?.membersTotal} />
        <ProjectsBox slug={slug} />
        <AssetsBox slug={slug} />
        {isCFUser ? <BirthdayBox slug={slug} /> : null}
      </div>
    </DynamicSearchProvider>
  )
}
